exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{background-color:#151515;margin:0 auto;padding:0 10px;max-width:1024px}#app{font-family:Avenir,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#d3d3d3;margin-top:40px}h1,h2{font-weight:400;text-align:center}li{text-align:left}a{color:inherit}#app>h1{margin-bottom:0}#app>h1 a{text-decoration:none}#app>h1 a.router-link-exact-active{cursor:default}.edgeTitle{text-align:center;font-size:20px;color:#f63e3e;margin-bottom:6px}.subtitle{color:#777;text-align:center}.subtitle a{color:#ccc;text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-24aad2b9","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 53
// module chunks = 0